export default {
  ext_id: {
    label: 'Transaction ID',
    required: true,
    valueKeys: ['$set', 'ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'transaction-id-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  n: {
    label: 'Product Name',
    required: false,
    valueKeys: ['$set', 'n'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'product-name-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  date: {
    label: 'Transaction Date',
    required: true,
    valueKeys: ['$set', 'date'],
    filters: ['trim', 'date'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'transaction-date-invalid',
        alertLevel: 'critical',
      },
      // {
      //   validator: 'matchRegexp',
      //   type: 'pre',
      //   params: [
      //     /((19|20)\d\d)-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])/,
      //   ],
      //   alertCode: 'transaction-date-invalid',
      //   alertLevel: 'critical',
      // },
      {
        validator: 'isDate',
        type: 'pre',
        params: [],
        alertCode: 'transaction-date-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  ext_salon_id: {
    label: 'Distributor Salon ID',
    required: true,
    valueKeys: ['$set', 'ext_salon_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'salon-id-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  ext_rep_id: {
    label: 'Distributor Rep ID',
    required: true,
    valueKeys: ['$set', 'ext_rep_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'rep-id-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  ext_prod_id: {
    label: 'Distributor Product ID',
    required: true,
    valueKeys: ['$set', 'ext_prod_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'product-id-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  qty: {
    label: 'Qty Sold',
    required: true,
    valueKeys: ['$set', 'qty'],
    filters: ['trim', 'integer'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'qty-invalid',
        alertLevel: 'critical',
      },
      {
        validator: 'isInt',
        type: 'pre',
        params: [],
        alertCode: 'qty-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  total: {
    label: 'Total Amount',
    required: true,
    valueKeys: ['$set', 'total'],
    filters: ['money'],
    validators: [
      {
        validator: 'isMoneyDecimal',
        type: 'pre',
        params: [],
        alertCode: 'product-price-invalid',
        alertLevel: 'critical',
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/configs/etl/sales/salesColumnsConfig.js